document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-page]').forEach(function (page) {
    var main = page.querySelector('[data-gallery-main]');
    page.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) { main.src = thumb.dataset.src; main.alt = thumb.dataset.alt || ''; }
        page.querySelectorAll('[data-gallery-thumb]').forEach(function (item) { item.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    var script = page.querySelector('[data-product-variants]');
    if (!script) return;
    var variants = JSON.parse(script.textContent);
    var form = page.querySelector('[data-product-form]');
    var id = page.querySelector('[data-variant-id]');
    var price = page.querySelector('[data-product-price]');
    var compare = page.querySelector('[data-product-compare]');
    var save = page.querySelector('[data-product-save]');
    var add = page.querySelector('[data-add-button]');
    var label = page.querySelector('[data-add-label]');
    var status = page.querySelector('[data-variant-status]');
    var quantityInput = page.querySelector('[data-bundle-quantity-input]');
    var summary = page.querySelector('[data-bundle-summary]');
    var sticky = page.querySelector('[data-sticky-cart]');
    var stickyAdd = page.querySelector('[data-sticky-add]');
    var stickyAddLabel = page.querySelector('[data-sticky-add-label]');
    var stickyQuantity = page.querySelector('[data-sticky-quantity]');
    var stickyMinus = page.querySelector('[data-sticky-minus]');
    var stickyPlus = page.querySelector('[data-sticky-plus]');
    var stickyOptions = page.querySelector('[data-sticky-options]');
    var stickySize = page.querySelector('[data-sticky-size]');
    var stickyColor = page.querySelector('[data-sticky-color]');
    var stickySwatch = page.querySelector('[data-sticky-swatch]');
    var groups = Array.prototype.slice.call(page.querySelectorAll('[data-option-group]'));
    var selected = groups.map(function (group) {
      var first = group.querySelector('[data-option-value]');
      var optionName = first ? (first.dataset.optionName || '').toLowerCase() : '';
      if (optionName === 'color') return null;
      var chosen = group.querySelector('[data-option-value].is-selected') || first;
      return chosen && chosen.dataset.optionValueName;
    });
    var selectedQuantity = 1;
    var currentVariant = null;
    var displayedVariant = null;
    var money = function (cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    };
    var bundleDiscount = function (quantity) { return quantity >= 3 ? 20 : quantity >= 2 ? 15 : 0; };
    var bundleTotal = function (unitPrice, quantity) {
      return Math.round(unitPrice * quantity * (100 - bundleDiscount(quantity)) / 100);
    };
    function optionValue(name) {
      var wanted = name.toLowerCase();
      for (var i = 0; i < groups.length; i += 1) {
        var button = groups[i].querySelector('[data-option-value]');
        if (button && (button.dataset.optionName || '').toLowerCase() === wanted) return selected[i] || '';
      }
      return '';
    }
    function colorHandle(value) {
      return String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    function updateSticky() {
      if (!sticky) return;
      var sizeValue = optionValue('Size');
      var colorValue = optionValue('Color');
      if (stickySize) stickySize.textContent = sizeValue || 'Selected size';
      if (stickyColor) stickyColor.textContent = colorValue || 'Selected color';
      if (stickySwatch) stickySwatch.className = 'lovable-color-swatch lovable-color-swatch--' + colorHandle(colorValue);
      if (stickyQuantity) stickyQuantity.textContent = selectedQuantity;
      var available = currentVariant && currentVariant.available;
      var total = displayedVariant ? bundleTotal(displayedVariant.price, selectedQuantity) : 0;
      if (stickyAdd) stickyAdd.disabled = !available;
      if (stickyAddLabel) {
        var missingColor = !colorValue;
        stickyAddLabel.textContent = available
          ? (selectedQuantity === 1 ? 'Add to bag — ' + money(total) : 'Add ' + selectedQuantity + ' — ' + money(total))
          : (missingColor ? 'Choose a color' : 'Sold out');
      }
    }
    function setQuantity(quantity) {
      selectedQuantity = Math.max(1, Math.min(10, Number(quantity) || 1));
      if (quantityInput) quantityInput.value = selectedQuantity;
      page.querySelectorAll('[data-bundle-quantity]').forEach(function (item) {
        var active = Number(item.dataset.bundleQuantity) === selectedQuantity;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      updateBundlePricing();
    }
    function updateBundlePricing() {
      if (!displayedVariant) { updateSticky(); return; }
      page.querySelectorAll('[data-bundle-quantity]').forEach(function (button) {
        var quantity = Number(button.dataset.bundleQuantity);
        var total = bundleTotal(displayedVariant.price, quantity);
        var priceTarget = button.querySelector('[data-bundle-price]');
        if (priceTarget) priceTarget.textContent = quantity === 1 ? money(displayedVariant.price) : money(total) + ' total';
      });
      var total = bundleTotal(displayedVariant.price, selectedQuantity);
      var perBed = Math.round(total / selectedQuantity);
      var savings = displayedVariant.price * selectedQuantity - total;
      if (summary) {
        summary.innerHTML = selectedQuantity === 1
          ? 'One bed at <strong>' + money(displayedVariant.price) + '</strong>.'
          : '<strong>' + money(total) + ' bundle total</strong><span>' + money(perBed) + ' per bed · You save ' + money(savings) + '</span>';
      }
      if (currentVariant && currentVariant.available) {
        label.textContent = selectedQuantity === 1 ? 'Add to bag' : 'Add ' + selectedQuantity + ' beds — ' + money(total);
      }
      updateSticky();
    }
    function update() {
      currentVariant = variants.find(function (item) {
        return item.options.every(function (value, index) { return value === selected[index]; });
      });
      displayedVariant = currentVariant || variants.find(function (item) {
        return item.available && item.options.every(function (value, index) {
          return !selected[index] || value === selected[index];
        });
      });
      groups.forEach(function (group, index) {
        var selection = group.querySelector('[data-option-selection]');
        var firstOption = group.querySelector('[data-option-value]');
        var groupName = firstOption ? (firstOption.dataset.optionName || '').toLowerCase() : '';
        if (selection) selection.textContent = selected[index] || (groupName === 'color' ? 'Choose one' : '');
        group.querySelectorAll('[data-option-value]').forEach(function (button) {
          var active = button.dataset.optionValueName === selected[index];
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          var possible = variants.some(function (item) {
            return item.available && item.options[index] === button.dataset.optionValueName && item.options.every(function (value, i) { return i === index || !selected[i] || value === selected[i]; });
          });
          button.disabled = !possible;
        });
      });
      if (!currentVariant) {
        var missingColor = !optionValue('Color');
        id.value = '';
        add.disabled = true;
        label.textContent = missingColor ? 'Choose a color' : 'Unavailable';
        status.textContent = missingColor ? 'Please choose a color to continue.' : 'This combination is unavailable.';
        if (displayedVariant) {
          price.textContent = money(displayedVariant.price);
          var previewSale = displayedVariant.compare_at_price && displayedVariant.compare_at_price > displayedVariant.price;
          compare.textContent = previewSale ? money(displayedVariant.compare_at_price) : '';
          compare.classList.toggle('is-hidden', !previewSale);
          save.textContent = previewSale ? 'Save ' + Math.round((displayedVariant.compare_at_price - displayedVariant.price) / displayedVariant.compare_at_price * 100) + '%' : '';
          save.classList.toggle('is-hidden', !previewSale);
        }
        updateBundlePricing();
        return;
      }
      id.value = currentVariant.id;
      price.textContent = money(currentVariant.price);
      var sale = currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price;
      compare.textContent = sale ? money(currentVariant.compare_at_price) : '';
      compare.classList.toggle('is-hidden', !sale);
      save.textContent = sale ? 'Save ' + Math.round((currentVariant.compare_at_price - currentVariant.price) / currentVariant.compare_at_price * 100) + '%' : '';
      save.classList.toggle('is-hidden', !sale);
      add.disabled = !currentVariant.available;
      status.textContent = currentVariant.available ? 'In stock and ready to ship.' : 'Currently sold out.';
      if (currentVariant.featured_image && main) { main.src = currentVariant.featured_image.src; main.alt = currentVariant.featured_image.alt || ''; }
      updateBundlePricing();
    }

    page.querySelectorAll('[data-option-value]').forEach(function (button) {
      button.addEventListener('click', function () {
        selected[Number(button.dataset.optionIndex)] = button.dataset.optionValueName;
        update();
      });
    });
    page.querySelectorAll('[data-bundle-quantity]').forEach(function (button) {
      button.addEventListener('click', function () { setQuantity(Number(button.dataset.bundleQuantity)); });
    });
    if (stickyMinus) stickyMinus.addEventListener('click', function () { setQuantity(selectedQuantity - 1); });
    if (stickyPlus) stickyPlus.addEventListener('click', function () { setQuantity(selectedQuantity + 1); });
    if (stickyOptions) {
      stickyOptions.addEventListener('click', function () {
        var optionPickers = page.querySelector('.lovable-option-pickers');
        if (!optionPickers) return;
        optionPickers.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(function () {
          var selectedOption = optionPickers.querySelector('[data-option-value].is-selected');
          if (selectedOption) selectedOption.focus({ preventScroll: true });
        }, 500);
      });
    }
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (!currentVariant || !currentVariant.available || !form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(add);
        else add.click();
      });
    }

    if (sticky && add) {
      var setStickyVisibility = function (visible) {
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          setStickyVisibility(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        }, { threshold: 0 });
        observer.observe(add);
      } else {
        window.addEventListener('scroll', function () {
          setStickyVisibility(add.getBoundingClientRect().bottom < 0);
        }, { passive: true });
      }
    }
    update();
  });
});
